import { render } from "./NewsCTA.vue?vue&type=template&id=e2177b30&scoped=true"
import script from "./NewsCTA.vue?vue&type=script&lang=js"
export * from "./NewsCTA.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-e2177b30"

export default script